module.exports = __webpack_public_path__ + "static/img/phone2.a7917ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/phone2.png
// module id = ZqhB
// module chunks = 0